import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import { apiClient } from '@services/apiClient';

import { type IAssetHealthOverview, type IAssetHealthOverviewKeys } from '../model/assetHealthOverview';

const assetHealthOverviewKey = (locationIds: Array<number>, urgency?: string) => [
  'assetHealthOverview',
  locationIds,
  urgency,
];

const assetHealthOverviewFn = ({ queryKey }: QueryFunctionContext<string[]>) => {
  return apiClient.get<{ data: IAssetHealthOverview }>(
    `${APP_API_URL_V2}fsd/action-item/executive-summary/asset-health`,
    {
      params: {
        location_ids: queryKey[1],
        urgency: queryKey[2],
      },
    },
  );
};

const assetHealthOverviewSelect = ({ data }: AxiosResponse<{ data: IAssetHealthOverview }>) => data.data;

export const useAssetHealthOverviewQuery = ({ locationIds, urgency }: IAssetHealthOverviewKeys) => {
  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: assetHealthOverviewKey(locationIds, urgency),
    queryFn: assetHealthOverviewFn,
    placeholderData: {
      data: {
        data: {
          sensors: {
            critical_regular_ais_count: 0,
            high_regular_ais_count: 0,
            standard_regular_ais_count: 0,
          },
          equipment: {
            critical_regular_ais_count: 0,
            high_regular_ais_count: 0,
            standard_regular_ais_count: 0,
          },
        },
      },
    },
    select: assetHealthOverviewSelect,
  });
};
